import { Popover } from 'antd'
import { memo } from 'react'
import { CodeBlock } from '@/components/CodeBlock'

const example = `[
  {
    "content": "你好，在吗？",
    "extra_info": {
      "答案1": "你好，在的",
      "答案2": "hello😄 怎么了？",
      "答案3": "你好",
      "答案4": "有什么可以帮到您？",
      "答案5": "😄😄😄😄"
    }
  }
]
`

function KnowledgeContentExampleContent() {
  return (
    <Popover
      getPopupContainer={triggerNode => triggerNode.parentNode as HTMLElement}
      trigger={['click']}
      overlayInnerStyle={{
        minWidth: 320,
        padding: '12px 16px',
      }}
      arrow={false}
      placement='bottom'
      align={{ offset: [0, 12] }}
      content={
        <>
          <div className='mb-12px line-height-16px text-12px font-500 text-#17171d'>
            数据内容的JSON格式请参照示例
          </div>
          <CodeBlock
            codeFont='12px'
            str={example}
            title='示例'
            lang='json'
            className='bg-white b-1 b-#e1e1e5 b-op-60'
            titleFont='12px'
          />
        </>
      }
    >
      <div className='absolute bottom-10 right-12 z-2 cursor-pointer c-#7B61FF'>
        示例
      </div>
    </Popover>
  )
}

export const KnowledgeContentExample = memo(KnowledgeContentExampleContent)
